import {CostItem} from "../standard-items/types";

const signupId = "signupCost"
const renewId  = "renewCost"

export const isSignupCost = (costItem:CostItem) =>
	costItem.id == signupId

export const isRenewCost = (costItem:CostItem) =>
	costItem.id == renewId

export const isAnnual = (costItem:CostItem) =>
	isSignupCost(costItem) || isRenewCost(costItem)



// WEBPACK FOOTER //
// ./src/membership3/pricing-option-form/common/utils.ts